module.exports = __webpack_public_path__ + "img/pay.c2fe8d1d.png";